// extracted by mini-css-extract-plugin
export default {"container":"container_uUECG","pagination":"pagination_cMs3O"};